const Header = function(){
    // I sort of wonder if this is needlessly small for a component...
    return(
        <header>
            <div>
                <h1>Rob's Blogs</h1>
                <h2>Creative, Collaborative, Completely Chaotic</h2>
            </div>
        </header>
    )
}

export default Header;